module.exports = __webpack_public_path__ + "static/media/BT.f5f34922.svg";